import api from './api';

const ENDPOINT = 'reports';

const ReportService = {
  get: (params = null) => api.get(ENDPOINT, { params }),
  download: (id) => api.get(`${ENDPOINT}/${id}`),
};

export default ReportService;
